query analyticsImpressionForCompany {
  analyticsImpression: analyticsImpressionForCompany
}
